export interface ServerErrorResponse {
  status: number;
  message?: string;
  errorCode?: string;
  errors: ServerValidationError[];
}

export function isServerErrorResponse(error: unknown): error is ServerErrorResponse {
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  return (error as ServerErrorResponse)?.errors !== undefined;
}

export interface ServerValidationError {
  isFieldError: boolean;
  fieldName?: string;
  errorMessage?: string;
  errorCode?: string;
  severity: 'Info' | 'Warning' | 'Error' | 'Critical';
}
